export const formatPhoneNumberForServer = (
	countryDial: string,
	localPhone: string
): string => {
	const dial = countryDial.replace('+', ''); // + 제거
	const phone = localPhone.replace(/^0/, ''); // 앞의 0만 제거
	return dial + phone;
};
